import {
  FreeSpinsInfoEvent,
  FreeSpinsGroup,
  FreeSpinsInfo,
  FreeSpinsInfoName,
} from '@cgs/data-access';
import { FreeSpinsGroupDto, FreeSpinsInfoDto } from '../../models';

export function mapFreeSpinsGroup(freeSpinsGroup: FreeSpinsGroupDto): FreeSpinsGroup {
  const result = new FreeSpinsGroup();
  result.count = freeSpinsGroup.count;
  result.usedCount = freeSpinsGroup.usedCount;
  result.bet = freeSpinsGroup.bet;
  result.lines = freeSpinsGroup.lines;
  result.name = freeSpinsGroup.name;
  result.win = freeSpinsGroup.win;
  result.betCalculation = freeSpinsGroup.betCalculation;
  result.multiplier = freeSpinsGroup.multiplier;
  return result;
}

export function freeSpinsInfoMapper(freeSpinsInfo: FreeSpinsInfoDto): FreeSpinsInfo {
  const result = new FreeSpinsInfo();
  result.freeSpinGroups = freeSpinsInfo.freeSpinGroups?.map(mapFreeSpinsGroup) || null;
  result.currentFreeSpinsGroup = freeSpinsInfo.currentFreeSpinsGroup
    ? mapFreeSpinsGroup(freeSpinsInfo.currentFreeSpinsGroup)
    : null;
  result.name = freeSpinsInfo.name as FreeSpinsInfoName;
  result.event = freeSpinsInfo.event as FreeSpinsInfoEvent;
  result.freeSpinsAdded = freeSpinsInfo.freeSpinsAdded;
  result.totalFreeSpins = freeSpinsInfo.totalFreeSpins!;
  result.totalWin = freeSpinsInfo.totalWin!;
  result.baseGameWin = freeSpinsInfo.baseGameWin || 0;
  result.parameter = freeSpinsInfo.parameter!;
  return result;
}
